/*
 * Lista de barras horizontales apiladas por rango de días (verde/amarillo/rojo).
 * Calca la visual de SimpleHorizontalChart del codekit (alto, radio, tipografía,
 * espacios y valor dentro de la barra) conservando el click de drill-down.
 */
import { Box } from "codekit";

import { bucketTokens, fmtMillions, toMillions } from "./utils/carthelp";

const SEGMENTS = ["verde", "amarillo", "rojo"];

/**
 * Renderiza barras apiladas proporcionales al total mayor, clickables
 * @param {Object} props Propiedades del componente
 * @param {Array} props.data Filas [{ label, verde, amarillo, rojo, total }]
 * @param {Function} props.onItemClick Callback con la fila y su índice al hacer click
 * @param {number} props.maxItems Filas visibles antes de activar el scroll vertical
 */
const Stakbars = ({ data = [], onItemClick, maxItems = 8 }) => {
  const nMax = Math.max(1, ...data.map((mItem) => mItem.total));
  const bClickable = typeof onItemClick === "function";
  const bScroll = data.length > maxItems;

  return (
    <div
      className="flex flex-col gap-3"
      style={bScroll ? { maxHeight: maxItems * 48 - 12, overflowY: "auto", paddingRight: 4 } : undefined}
    >
      {data.map((mItem, nIndex) => (
        <div key={nIndex} className="flex items-center gap-3">
          <span className="text-xs text-neutral-500 shrink-0 text-right" style={{ width: 140 }} title={mItem.label}>
            {mItem.label}
          </span>
          <div className="flex-1 relative rounded overflow-hidden bg-neutral-100" style={{ height: 36 }}>
            <div
              className="h-full flex rounded overflow-hidden transition-all"
              onClick={bClickable ? () => onItemClick(mItem, nIndex) : undefined}
              style={{
                width: `${(mItem.total / nMax) * 100}%`,
                minWidth: mItem.total > 0 ? 32 : 0,
                cursor: bClickable ? "pointer" : "default",
              }}
            >
              {SEGMENTS.map((sSeg) =>
                mItem[sSeg] > 0 ? (
                  <Box
                    key={sSeg}
                    bg={bucketTokens[sSeg]}
                    style={{ width: `${(mItem[sSeg] / mItem.total) * 100}%`, height: "100%" }}
                  />
                ) : null,
              )}
            </div>
            {mItem.total > 0 && (
              <span
                className="flex items-center px-3 text-white font-bold font-mono text-sm leading-none pointer-events-none"
                style={{ position: "absolute", top: 0, bottom: 0, left: 0 }}
              >
                {toMillions(mItem.total)}
              </span>
            )}
          </div>
          <span className="text-xs font-semibold shrink-0 text-neutral-500" style={{ minWidth: 48 }}>
            {fmtMillions(mItem.total)}
          </span>
        </div>
      ))}
    </div>
  );
};

export default Stakbars;
